import { useCallback } from 'react'
import {
  DeleteItemConfirmation,
  DeleteItemConfirmationProps,
} from 'components/Handbook2_0/Sidebar/DeleteItemConfirmation'
import { useModals } from 'almanac-ui/Modal'

export const useHandbookItemDeleteConfirmationModal = () => {
  const { openModal } = useModals()

  const openHandbookItemDeleteConfirmationModal = useCallback(
    (props: Omit<DeleteItemConfirmationProps, 'isOpen'>) => {
      openModal(DeleteItemConfirmation, {
        ...props,
      })
    },
    [openModal],
  )

  return openHandbookItemDeleteConfirmationModal
}

export default useHandbookItemDeleteConfirmationModal
